module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-02-6144727142fe8bf0d8f62b50018c9dcb.png";